import { EVENT_BUS } from "~/fc/constants";
import {
  STATUS_CONVERTING,
  STATUS_ERROR,
  STATUS_LABELS,
  STATUS_UPLOADING,
} from "~/fc/Constants/job-status";

export default {
  data: () => ({
    jobProgressStatuses: [STATUS_UPLOADING, STATUS_CONVERTING],
    jobWatcherTimer: null,
  }),
  computed: {
    tasks() {
      return this.$store.state.items.tasks;
    },
  },
  methods: {
    watchStuckJobs() {
      if (this.jobWatcherTimer) {
        clearInterval(this.jobWatcherTimer);
      }

      this.jobWatcherTimer = setInterval(() => {
        // if internet is not available
        if (!this.$store.state.isInternetAvailable) return;

        for (const jobId in this.jobs) {
          if (
            !this.jobs.hasOwnProperty(jobId) ||
            !this.jobProgressStatuses.includes(this.jobs[jobId].status) ||
            this.jobs[jobId].isBulkItemJob // ignore job that has multiple import file
          ) {
            continue;
          }

          const timeDiff = Date.now() - this.jobs[jobId].lastAcknowledgedTime;
          // 'lastAcknowledgedTime' for every job is updated from
          // 1. resumable progress
          // 2. validating upload(join call)
          // 3. completing upload(upload api call)
          // 4. every task event from socket
          if (
            this.jobs[jobId].status === STATUS_UPLOADING &&
            timeDiff > 1200000 // 20 mins
          ) {
            // cancel the resumable upload
            this.$bus.$emit(EVENT_BUS.CANCEL_UPLOAD);
            this.$sentry.captureEvent({
              message: `job stuck at upload`,
              extra: {
                jobId,
              },
            });
          } else if (
            this.jobs[jobId].status === STATUS_CONVERTING &&
            this.jobs[jobId].progress == 100 &&
            timeDiff > 60000 //  1 min
          ) {
            // get the convert/compress task and mark as fail
            for (const taskId of this.jobs[jobId].tasks) {
              const task = this.tasks[taskId];
              if (["convert", "compress"].includes(task.name)) {
                this.$store.commit("items/taskFailed", {
                  id: taskId,
                  type: "custom",
                  status: STATUS_ERROR,
                  statusText: STATUS_LABELS[STATUS_ERROR],
                  statusTitle: $nuxt.$t("process_completion_timeout"),
                });
                this.$sentry.captureEvent({
                  message: `job stuck at ${task.name} 100%`,
                  extra: {
                    jobId,
                    taskId,
                  },
                });
                break;
              }
            }
          }
        }
      }, 60000);
    },
  },
  mounted() {
    this.$bus.$on(EVENT_BUS.RESTART_STUCK_JOB_WATCHER, () => {
      this.watchStuckJobs();
    });
  },
};
